import * as yup from "yup";

export type StepVerifyEmailSchema = {
  pendingToken: string;
  code: string;
};

export const StepVerifyEmailSchema: yup.ObjectSchema<StepVerifyEmailSchema> = yup.object({
  pendingToken: yup.string().required(),
  code: yup.string().required().min(6).max(6),
});
